module.exports = __webpack_public_path__ + "img/logo_completo.7ff941cd.svg";